import { ActiveItem } from '../constants';

/**
 * Checks if a tab value matches the active state.
 * Handles query string parameters by comparing the base path.
 *
 * @param value - The tab's value (may include query string like "path?param=value")
 * @param active - The current active state
 * @returns true if the tab is considered active
 */
export function isTabActive(
  value: string,
  active: ActiveItem | undefined,
): boolean {
  // Handle undefined/null active - never active
  if (active === undefined || active === null) return false;

  // Direct match (including empty string === empty string)
  if (value === active) return true;

  // Match ignoring query string
  const baseValue = value.split('?')[0];
  if (baseValue === active) return true;

  return false;
}

/**
 * Checks if any item in a collection is active.
 * Uses the same logic as isTabActive for consistency.
 *
 * @param items - Array of items with value property
 * @param active - The current active state
 * @returns true if any item matches the active state
 */
export function hasActiveItem(
  items: Array<{ value: string }>,
  active: ActiveItem | undefined,
): boolean {
  return items.some((item) => isTabActive(item.value, active));
}
